import { render } from "./PrintHeaderDesign4.vue?vue&type=template&id=4ed2dbf8&scoped=true"
import script from "./PrintHeaderDesign4.vue?vue&type=script&lang=js"
export * from "./PrintHeaderDesign4.vue?vue&type=script&lang=js"

import "./PrintHeaderDesign4.vue?vue&type=style&index=0&id=4ed2dbf8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed2dbf8"]])

export default __exports__